import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../core/Button';

interface RecurringWOPlanListProps {
  plans: RecurringPlan[];
  onClose: () => void;
  isProcessing: boolean;
  onSelect: (id: string) => void;
  onNewPlan: () => void;
}

const RecurringWOPlanList: FC<RecurringWOPlanListProps> = ({
  plans,
  isProcessing,
  onClose,
  onSelect,
  onNewPlan,
}) => {
  return (
    <>
      <div className="min-h-0 flex-1 overflow-y-auto px-6 pb-5">
        <div className="flex flex-row">
          <div className="grow basis-0">
            <ul className="py-2">
              {plans.map((plan) => {
                const subtitle =
                  plan.periodicity.type === 'monthly' ? (
                    <FormattedMessage
                      id="recurring_plan_dialog.executes_x_times_per_month"
                      defaultMessage="Executes {occurrences} {occurrences, plural, one {time} other {times}} per month"
                      values={{
                        occurrences: plan.periodicity.occurrences.length,
                      }}
                    />
                  ) : (
                    <FormattedMessage
                      id="recurring_plan_dialog.executes_x_times_per_year"
                      defaultMessage="Executes {occurrences} {occurrences, plural, one {time} other {times}} per year"
                      values={{
                        occurrences: plan.periodicity.occurrences.length,
                      }}
                    />
                  );
                return (
                  <li key={plan.id}>
                    <button
                      type="button"
                      className="flex w-full flex-col items-start px-4 py-1 text-left hover:bg-background-300"
                      onClick={() => onSelect(plan.id)}
                    >
                      <span className="text-base leading-6">{plan.title}</span>
                      <span className="text-sm leading-5 text-text-800">
                        {subtitle}
                      </span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="flex grow basis-0 flex-col items-center justify-center">
            <p className="text-base leading-6">
              <FormattedMessage
                id="recurring_plan_dialog.select_plan_to_the_left_or_create_new"
                defaultMessage="Select recurring work order plan in the left list or create a new plan."
              />
            </p>
            <Button variant="filled" className="mt-4" onClick={onNewPlan}>
              <FormattedMessage
                id="recurring_plan_dialog.new_check_in_plan"
                defaultMessage="New check-in plan"
              />
            </Button>
          </div>
        </div>
      </div>
      <div className="flex shrink-0 flex-row items-center justify-end p-2">
        <Button variant="outline" loading={isProcessing} onClick={onClose}>
          <FormattedMessage id="close" defaultMessage="Close" />
        </Button>
      </div>
    </>
  );
};

export default RecurringWOPlanList;
